import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslationStore } from "../../stores/translation.store";
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
import * as i2 from "../../stores/translation.store";
export class MaterialSnackbarNotifier {
    constructor(snackBar, translationStore) {
        this.snackBar = snackBar;
        this.translationStore = translationStore;
    }
    info(title, message, onClose) {
        void this.openDialog(title, message, onClose, "info");
    }
    success(title, message, onClose) {
        void this.openDialog(title, message, onClose, "info");
    }
    debug(title, message, onClose) {
        void this.openDialog(title, message, onClose, "info");
    }
    warn(title, message, onClose) {
        void this.openDialog(title, message, onClose, "warn");
    }
    error(title, message, onClose) {
        void this.openDialog(title, message, onClose, "error");
    }
    async confirmation(title, message, buttons, callback) {
        return new Promise((resolve, reject) => {
            void this.openDialog(title, message, (dismissed) => {
                if (dismissed) {
                    if (typeof callback === "function")
                        callback(true);
                    resolve(true);
                }
                else {
                    if (typeof callback === "function")
                        callback(false);
                    resolve(false);
                }
            }, "info", buttons instanceof Array ? buttons[0]?.label : undefined);
        });
    }
    openDialog(title, message, onClose, cssClass, buttonText = "@@actions.ok") {
        title = this.translationStore.translate(title, { showMissingKey: true });
        message = this.translationStore.translate(message, { showMissingKey: true });
        let text = title;
        if (message)
            text += ` - ${message}`;
        if (this.snackBar) {
            this.snackBar
                .open(text, this.translationStore.translate(buttonText, { showMissingKey: true }).toUpperCase(), {
                announcementMessage: text,
                duration: 10000,
                panelClass: `snackbar-${cssClass}`,
                horizontalPosition: "right",
                verticalPosition: "bottom"
            })
                .afterDismissed()
                .subscribe((dismiss) => {
                if (dismiss.dismissedByAction) {
                    if (typeof onClose === "function")
                        onClose(true);
                }
                else if (typeof onClose === "function")
                    onClose(false);
            });
        }
    }
}
MaterialSnackbarNotifier.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: MaterialSnackbarNotifier, deps: [{ token: i1.MatSnackBar }, { token: i2.TranslationStore }], target: i0.ɵɵFactoryTarget.Injectable });
MaterialSnackbarNotifier.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: MaterialSnackbarNotifier });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: MaterialSnackbarNotifier, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.MatSnackBar }, { type: i2.TranslationStore }]; } });
